<script setup>
import { computed } from 'vue'
import { SText, SIcon } from '@n966/soilbox_ui'

import { useRulerStore } from '@/store/ruler'
import { getDataFromLS } from '@/utils'

const rulerStore = useRulerStore()

const iconsConfig = [
  {
    icon: 'copy',
    id: 'copy'
  },
  {
    icon: 'trash-can',
    id: 'delete'
  },
  {
    icon: 'close',
    id: 'close'
  }
]

const isShowPopup = computed(() => {
  return rulerStore.lastPointData && rulerStore.points.length > 1
})

const clickHandler = (id) => {
  switch (id) {
    case 'delete':
      {
        rulerStore.removeLastPoint()
        const lastItem = rulerStore.points[rulerStore.points.length - 1]
        rulerStore.setLastPoint(lastItem)
      }
      break
    case 'copy':
      {
        navigator.clipboard
          .writeText(formattedDistance.value)
          .then(() => {
            rulerStore.setShowNotify(true)
          })
          .catch((err) => {
            console.error('Ошибка при копировании:', err)
          })
      }
      break
    case 'close':
      {
        const isShow = getDataFromLS('show-ruler')

        if (isShow !== false) {
          rulerStore.setIsShowRulerModal(true)
        } else {
          rulerStore.setClearAssets(true)
        }
      }
      break
  }
}

const formattedDistance = computed(() => {
  return parseFloat(rulerStore.totalDistance.toFixed(2))
})
</script>

<template>
  <div
    class="map-popup"
    :class="{ show: isShowPopup }"
  >
    <div class="map-popup__distance">
      <s-text>{{ formattedDistance }} м</s-text>
    </div>
    <div
      @click="clickHandler(item.id)"
      class="map-popup__icon"
      v-for="item in iconsConfig"
      :key="item.id"
    >
      <s-icon :name="item.icon" />
    </div>
  </div>
</template>

<style lang="scss">
.s-map {
  & .mapboxgl-popup-content:has(.map-popup) {
    border-radius: 10px;
    padding: 0;
  }

  & .mapboxgl-popup-content {
    background: transparent;
  }

  & .mapboxgl-popup-tip {
    display: none;
  }
  & .mapboxgl-popup-anchor-bottom:has(.map-popup) {
    left: 7%;
  }
}

#map {
  & .map-popup {
    position: relative;
    flex-direction: row;
    display: none;
    align-items: center;
    gap: 16px;
    background-color: var(--secondary-bg);
    border: 1px solid var(--bg);
    height: 40px;
    min-width: auto;
    border-radius: 8px;
    padding: 0 12px;

    &.show {
      display: flex;
    }

    &__distance {
      flex-shrink: 0;
      user-select: none;
    }

    &__icon {
      cursor: pointer;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;

      &:last-child {
        border-left: 1px solid var(--bg);
        padding-left: 12px;
      }
    }

    & svg {
      height: 16px;
    }
  }
}
</style>
